export default {
    missingEmail: "Login failed. {0} have not given e-mail address. Use different login method.",
};
